import { render } from "./rule.vue?vue&type=template&id=4ce4b3f3"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"

import "./rule.vue?vue&type=style&index=0&id=4ce4b3f3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__